export const CONST_waiting_for_regain = "waiting_for_regain";

export const bookingStatusConst = {
  [CONST_waiting_for_regain]: 6
};
